import { DatePicker, Select, Table, TableColumnsType } from 'antd';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import Button from '../../components/Button';
import SimpleHeader from '../../components/layout/SimpleHeader';
import SelectCampus from '../../components/SelectCampus';
import useAxios from '../../hooks/useAxios';
import useNotification from '../../hooks/useNotification';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/rootReducer';
import { getPaymentRecords } from '../../api/payments.api';
import {
  IGetPaymentRecords,
  IPaymentRecord,
} from '../../models/payments.model';
import DownloadButton from '../../components/DownloadButton';
import PaymentDetailModal from '../../components/payment/record/modals/PaymentDetailModal';
import DatePickerTable from '../../components/statistics/DatePickerTable';
import exportTable from '../../lib/exportTable';
import _ from 'lodash';
import {
  IGetSemesterMonths,
  IGetSemesters,
  ISemester,
} from '../../models/semesters.model';
import { getSemesterMonths, getSemesters } from '../../api/semesters.api';
import Pagination from '../../components/Pagination';
import config from '../../lib/config';
import useUtil from '../../hooks/useUtil';
import useLoader from '../../hooks/useLoader';
import EduStepSelect from '../../components/common/EduStepSelect';
import { DateTableType } from '../../constans';
import TableEmpty from '../../components/common/TableEmpty';
import { ISelect } from '../../models/common.model';

const PaymentRecord: FC = () => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { infoNotification } = useNotification();
  const { getCommonCodeLabel } = useUtil();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0005 = 연도
  const SY0005 = commonCodes.find(
    (item) => item.commonCode === 'SY0005',
  )?.detailCode;
  const _SY0005 = _.orderBy(SY0005, ['orderSeq'], ['desc']);
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find(
    (item) => item.commonCode === 'PR0002',
  )?.detailCode;

  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetPaymentRecords>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetSemesters>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetSemesterMonths>();
  // for excel download
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetPaymentRecords>();
  useLoader(
    isLoading || isLoading2 || isLoading3 || isLoading4,
    [error, error2, error3, error4],
  );

  const [isFirstRun, setIsFirstRun] = useState(true);
  const [target, setTarget] = useState<string>();
  const [method, setMethod] = useState<string>();
  const [channel, setChannel] = useState<string>();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [semesterCode, setSemesterCode] = useState<string>();
  const [monthSeq, setMonthSeq] = useState<string>();
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [pageNo, setPageNo] = useState(1);
  const [paymentDetailVisible, setPaymentDetailVisible] = useState(false);
  const [paymentRecordCode, setPaymentRecordCode] = useState<number>();
  const [defSelType, setDefSelType] = useState<number>(2);
  const [year, setYear] = useState('');
  const [semesterType, setSemesterType] = useState("");
  const [semesterData, setSemesterData] = useState<ISemester[]>([]);

  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }
    doGetPaymentRecords(pageNo);
  }, [pageNo]);

  useEffect(() => {
    execute2(getSemesters());
  }, []);

  useEffect(() => {
    if (semesterCode) {
      execute3(getSemesterMonths(String(semesterCode)));
    }
  }, [semesterCode]);

  useEffect(() => {
    if (serverDate) {
      const date = moment(serverDate).format('YYYYMMDD');
      setStartDate(date);
      setEndDate(date);
    }
  }, [serverDate]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
    setSemesterCode(undefined);
  }, [year]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
    setSemesterCode(undefined);
  }, [semesterType]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
  }, [res2]);

  useEffect(() => {
    if (res4?.data) {
      const data = _.cloneDeep(res4.data);
      data.forEach((item: any) => {
        item.monthNameCode = getCommonCodeLabel('SY0009', item.monthNameCode?.trim());
        item.paymentTargetCode = getCommonCodeLabel('PA0001',
          item.paymentTargetCode);
        item.paymentMtdCode = getCommonCodeLabel('PA0002',
          item.paymentMtdCode);
        item.price = item.price;
        item.discountAmount = item.discountAmount;
        item.paymentAmount = item.paymentAmount;
        item.paymentSttCode = getCommonCodeLabel('PA0003',
          item.paymentSttCode);
        item.paymentCloseDate = item.paymentCloseDate
          ? moment(item.paymentCloseDate).format('YYYY.MM.DD')
          : '';
        item.paymentDttm = item.paymentDttm
          ? moment(item.paymentDttm).format('YYYY.MM.DD HH:mm')
          : '';
        item.eduStepCode = getCommonCodeLabel('PR0006', item.eduStepCode);
      });
      const currentDate = moment(new Date());
      exportTable(
        columns,
        data,
        `${t('payment.record.1')}_(${currentDate.format('YYYYMMDD')})`,
        t('payment.record.1'),
        [15, 15, 10, 20, 15, 10, 10, 10, 20, 15, 15, 15, 10, 15, 20],
      );
    }
  }, [res4]);

  const doGetPaymentRecords = (pageNo: number, perPage?: number) => {
    if (!startDate || !endDate) {
      return infoNotification(t('payment.charge.message1'));
    }
    setPageNo(pageNo);

    const req: any = {
      campusCode: currentCampus,
      srtDate: startDate,
      endDate: endDate,
      perPage: perPage || config.pageSize,
      pageNo,
      paymentTargetCode: target,
      paymentMtdCode: method,
      paymentChannelCode: channel,
      semesterCode,
      monthSeq,
      eduStepCode,
    };

    perPage
      ? execute4(getPaymentRecords(req))
      : execute(getPaymentRecords(req));
  };

  const onSetTarget = (value: string) => {
    setTarget(value);
    if (value === 'PT') {
      setSemesterCode(undefined);
      setMonthSeq(undefined);
    }
  };

  const fnSetSemesterData = (year : string, semesterType : string) => {
    if(res2) {
      let data: ISemester[] = _.cloneDeep(res2.data);

      if(year) {
        data = data.filter((item: any) => item.learningYearCode === year);
      }

      if(semesterType) {
        data = data.filter((item: any) => item.semesterType === semesterType);
      }

      setSemesterData(data);
    }
  }

  const columns: TableColumnsType<IPaymentRecord> = [
    {
      title: '#',
      dataIndex: 'paymentRecordCode',
      align: 'center',
    },
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value),
    },
    {
      title: t('common.column.semester'),
      dataIndex: 'semesterName',
      align: 'center',
    },
    {
      title: t('payment.charge.column1'),
      dataIndex: 'monthNameCode',
      align: 'center',
      render: value => getCommonCodeLabel('SY0009', value?.trim()),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      align: 'center',
    },
    {
      title: t('payment.charge.column3'),
      dataIndex: 'paymentTargetCode',
      align: 'center',
      render: value => getCommonCodeLabel('PA0001', value),
    },
    {
      title: t('payment.record.column1'),
      dataIndex: 'paymentMtdCode',
      align: 'center',
      render: value => getCommonCodeLabel('PA0002', value),
    },
    {
      title: t('payment.coupon.placeholder2'),
      dataIndex: 'memberName',
      align: 'center',
      render: (value, record) => (
        <span
          className="pointer"
          onClick={() => {
            setPaymentRecordCode(record.paymentRecordCode);
            setPaymentDetailVisible(true);
          }}
        >
          <u>{value}</u>
        </span>
      ),
    },
    {
      title: t('payment.overallSales.10'),
      dataIndex: 'parentName',
      align: 'center',
    },
    {
      title: t('payment.charge.column4'),
      dataIndex: 'memberCode',
      align: 'center',
    },
    {
      title: t('payment.charge.column5'),
      dataIndex: 'price',
      align: 'center',
      render: value => value?.toLocaleString(),
    },
    {
      title: t('payment.record.column2'),
      dataIndex: 'discountAmount',
      align: 'center',
      render: value => value?.toLocaleString(),
    },
    {
      title: t('payment.record.column3'),
      dataIndex: 'paymentAmount',
      align: 'center',
      render: value => value?.toLocaleString(),
    },
    {
      title: t('common.column.status'),
      dataIndex: 'paymentSttCode',
      align: 'center',
      render: value => getCommonCodeLabel('PA0003', value),
    },
    {
      title: t('payment.charge.column7'),
      dataIndex: 'paymentCloseDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('payment.record.column4'),
      dataIndex: 'paymentDttm',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD HH:mm'),
    },
  ];

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>{t('payment.charge.column3')}</label>
            <div>
              <Select
                placeholder={t('payment.charge.column3')}
                value={target}
                onChange={(value) => onSetTarget(value)}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                <Select.Option value="PT">
                  {t('payment.charge.option1')}
                </Select.Option>
                <Select.Option value="TU">
                  {t('payment.charge.option2')}
                </Select.Option>
                <Select.Option value="ON">
                  {t('payment.charge.option3')}
                </Select.Option>
                <Select.Option value="AL">
                  {t('payment.charge.option4')}
                </Select.Option>
                <Select.Option value="ST">
                  {t('payment.charge.option5')}
                </Select.Option>
                <Select.Option value="SC">
                  {t('payment.charge.option6')}
                </Select.Option>
                <Select.Option value="ET">
                  기타
                </Select.Option>
              </Select>
            </div>
          </li>
          <li>
            <label>{t('payment.record.column1')}</label>
            <div>
              <Select
                placeholder={t('payment.record.column1')}
                value={method}
                onChange={(value) => setMethod(value)}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                <Select.Option value="CD">
                  {t('payment.record.option1')}
                </Select.Option>
                <Select.Option value="TF">
                  {t('payment.record.option2')}
                </Select.Option>
              </Select>
            </div>
          </li>
          <li>
            <label>{t('payment.charge.placeholder2')}</label>
            <div>
              <Select
                placeholder={t('payment.charge.placeholder2')}
                value={channel}
                onChange={(value) => setChannel(value)}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                <Select.Option value="ON">
                  {t('payment.record.option3')}
                </Select.Option>
                <Select.Option value="PO">
                  {t('payment.record.option4')}
                </Select.Option>
              </Select>
            </div>
          </li>
          <li>
            <label>
              {t('program.semester.column9')}
            </label>
            <Select
              className="w-120p"
              value={year}
              onChange={value => setYear(value)}
            >
              <Select.Option key={'all'} value={''}>
                {t('common.text.all')}
              </Select.Option>
              {
                _SY0005!.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>
          <li>
            <label>
              {t('program.semester.column11')}
            </label>
            <Select
              className="w-120p"
              value={semesterType}
              onChange={value => setSemesterType(value)}
            >
              <Select.Option key={'all'} value={''}>
                {t('common.text.all')}
              </Select.Option>
              {
                PR0002?.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>          
          <li>
            <label>{t('common.column.semester')}</label>
            <div>
              <Select
                placeholder={t('statistics.regularTest.placeholder2')}
                value={semesterCode}
                onChange={(value) => setSemesterCode(value)}
                disabled={target === 'PT'}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {semesterData?.map((item) => (
                  <Select.Option
                    key={item.semesterCode}
                    value={item.semesterCode}
                  >
                    {item.semesterName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('payment.charge.column1')}</label>
            <div>
              <Select
                placeholder={t('payment.charge.column1')}
                value={monthSeq}
                onChange={(value) => setMonthSeq(value)}
                disabled={!semesterCode || target === 'PT'}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {res3?.data?.map((item) => (
                  <Select.Option
                    key={item.monthSeq}
                    value={item.monthSeq}
                  >
                    {item.monthName}
                    {t('payment.charge.text4')}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('common.placeholder.1')}</label>
            <div>
              <EduStepSelect
                eduStepCode={eduStepCode}
                setEduStepCode={setEduStepCode}
                includeAll
                fullWidth
              />
            </div>
          </li>
          <li className="period">
            <label>{t('sms.list.column1')}</label>
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center ">  
                <div className="date-picker__area">
                  <DatePicker
                    value={startDate ? moment(startDate) : undefined}
                    onChange={(e) => {
                      if (e === null) setStartDate('');
                      else setStartDate(moment(e).format('YYYYMMDD'));
                    }}
                  />
                  ~
                  <DatePicker
                    value={endDate ? moment(endDate) : undefined}
                    onChange={(e) => {
                      if (e === null) setEndDate('');
                      else setEndDate(moment(e).format('YYYYMMDD'));
                    }}
                  />
                </div>
                <div className="comm-btn__area">
                  <Button
                    className="btn-basic small black"
                    onClick={() => doGetPaymentRecords(1)}
                    text={t('common.button.search')}
                  />
                </div>
              </div>
              <div className="comm-btn__area mt-2">
                <DatePickerTable
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  type={DateTableType.ALL}
                  defSelType={defSelType}
                  setDefSelType={setDefSelType}
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>	
    <div className="content scrollbar">
      <SimpleHeader
        iconFile="icon-payment-big.svg"
        parentMenu={t('common.menu.payment')}
        currentMenu={t('payment.record.title1')}
        onlyTitle={true}
      />
      <div className="col-frame">
        {res?.data?.length ? (
          <div>
            <div className="comm-bx__between">
              <div className="comm-sch_result">
                {t('payment.charge.text5')}:{' '}
                <b>{res?.totalPayment?.toLocaleString()}</b>
                {t('payment.charge.text2')}
              </div>
            </div>
            <div className='comm-table__area'>
              <Table
                columns={columns}
                dataSource={res?.data}
                pagination={{
                  current: pageNo,
                  pageSize: config.pageSize,
                }}
              />
            </div>
            <div className="comm-bx__between">              
              <DownloadButton onClick={() => doGetPaymentRecords(1, 999999999)}/>
              <div className="common-paging center">
                <Pagination
                  count={res?.total || 0}
                  page={pageNo}
                  setPage={setPageNo}
                />
              </div>
            </div>
          </div>
        ) : (
          <TableEmpty text={t('payment.charge.text3')} />
        )}
      </div>

      {paymentDetailVisible && (
        <PaymentDetailModal
          visible={paymentDetailVisible}
          setVisible={setPaymentDetailVisible}
          paymentRecordCode={paymentRecordCode}
        />
      )}
    </div>
    </>
  );
};

export default PaymentRecord;
